import React from 'react'

import BaseAssemblyFormBlock from './BaseAssemblyFormBlock'

const AutoRefinanceFormBlock = () => {
  return <BaseAssemblyFormBlock formId='4955889' height='600' />
}

export default React.memo(AutoRefinanceFormBlock)
